import Service from "../../services";
// eslint-disable-next-line no-unused-vars
import Swal from "sweetalert2";

const plantsModule = {
  namespaced: true,
  state: {
    plants_survey: [],
    plants_bank: [],
    list_save: [],
    bank_form: {
      bank_plot_code: "", //รหัสแปลง
      bank_plot_name: "", //ชื่อแปลง
      bank_plot_address: "", //ที่ตั้งแปลง
      bank_plot_sub_district: "", //ที่ตั้งแปลง ตำบล
      bank_plot_district: "", //ที่ตั้งแปลง อำเภอ
      bank_plot_province: "", //ที่ตั้งแปลง จังหวัด
      bank_date: "", //วันที่สำรวจพบ
      bank_amount: "", //จำนวนต้นที่พบ
      bank_bio_lat: "", //พิกัดต้นพันธุ์ lat
      bank_bio_lon: "", //พิกัดต้นพันธุ์ lon
      bank_plot_lat: "", //พิกัดแปลง lat
      bank_plot_lon: "", //พิกัดแปลง lon
    },
  },

  mutations: {
    CLEAR_PLANT(state) {
      state.bank_form = {
        bank_plot_code: "", //รหัสแปลง
        bank_plot_name: "", //ชื่อแปลง
        bank_plot_address: "", //ที่ตั้งแปลง
        bank_plot_sub_district: "", //ที่ตั้งแปลง ตำบล
        bank_plot_district: "", //ที่ตั้งแปลง อำเภอ
        bank_plot_province: "", //ที่ตั้งแปลง จังหวัด
        bank_date: "", //วันที่สำรวจพบ
        bank_amount: "", //จำนวนต้นที่พบ
        bank_bio_lat: "", //พิกัดต้นพันธุ์ lat
        bank_bio_lon: "", //พิกัดต้นพันธุ์ lon
        bank_plot_lat: "", //พิกัดแปลง lat
        bank_plot_lon: "", //พิกัดแปลง lon
      };
      state.list_save = [];
    },
    CLEAR_BANK_FORM(state) {
      state.bank_form = {
        bank_plot_code: "", //รหัสแปลง
        bank_plot_name: "", //ชื่อแปลง
        bank_plot_address: "", //ที่ตั้งแปลง
        bank_plot_sub_district: "", //ที่ตั้งแปลง ตำบล
        bank_plot_district: "", //ที่ตั้งแปลง อำเภอ
        bank_plot_province: "", //ที่ตั้งแปลง จังหวัด
        bank_date: "", //วันที่สำรวจพบ
        bank_amount: "", //จำนวนต้นที่พบ
        bank_bio_lat: "", //พิกัดต้นพันธุ์ lat
        bank_bio_lon: "", //พิกัดต้นพันธุ์ lon
        bank_plot_lat: "", //พิกัดแปลง lat
        bank_plot_lon: "", //พิกัดแปลง lon
      };
    },
    SET_PLANT(state, data) {
      state.plants_survey = [];
      state.plants_bank = [];
      state.plants_survey = data.plants_survey;
      state.plants_bank = data.plants_bank;
    },
    SET_LIST_BANK(state, data) {
      state.list_save = [];
      data.forEach((items) => {
        items.forEach((item) => {
          state.list_save.push(item);
        });
      });
      console.log("state.list_save", state.list_save);
    },
  },
  actions: {
    clearPlant({ commit }) {
      commit("CLEAR_PLANT");
    },
    clearBankPlant({ commit }) {
      commit("CLEAR_BANK_FORM");
    },
    getAllPlants({ commit }, data) {
      return Service.FormAPI.getPlants(data).then((res) => {
        console.log(res);
        if (res.code == 200) {
          // console.log("res.result", res.result);
          commit("SET_PLANT", res.result);
          return res;
        } else {
          Swal.fire({
            icon: "error",
            title: "ผิดพลาด!",
          });
        }
      });
    },
    onSearchPlants({ commit }, data) {
      return Service.FormAPI.getSearchPlants(data).then((res) => {
        if (res.code == 200) {
          console.log("res.result", res.result);
          commit("SET_PLANT", res.result);
          return res;
        } else {
          Swal.fire({
            icon: "error",
            title: "ผิดพลาด!",
          });
        }
      });
    },
    getAllPlantsForProfessor({ commit }, data) {
      return Service.FormAPI.getPlantsForProfessor(data).then((res) => {
        if (res.code == 200) {
          console.log("res.result", res.result);
          commit("SET_PLANT", res.result);
          return res;
        } else {
          Swal.fire({
            icon: "error",
            title: "ผิดพลาด!",
          });
        }
      });
    },
    saveListBank({ commit }, data) {
      commit("SET_LIST_BANK", data);
    },
    // eslint-disable-next-line no-unused-vars
    onSaveFormToBank({ commit }, data) {
      return Service.FormAPI.saveTobank(data).then((res) => {
        if (res.code == 200) {
          console.log("res.result", res.result);
          return res;
        } else {
          Swal.fire({
            icon: "error",
            title: "ผิดพลาด!",
          });
        }
      });
    },
    // eslint-disable-next-line no-unused-vars
    onEditStatusPlant({ commit }, data) {
      return Service.FormAPI.editStatus(data).then((res) => {
        if (res.code == 200) {
          return res;
        }
      });
    },
    // eslint-disable-next-line no-unused-vars
    onCheckAvailable({ commit }, data) {
      return Service.FormAPI.checkAvailableOfPlant(data).then((res) => {
        if (res.code == 200) {
          return res;
        } else {
          Swal.fire({
            icon: "error",
            title: "ผิดพลาด!",
          });
        }
      });
    },
    onDeleteBulkplant({ commit }, payload) {
      return Service.FormAPI.deleteBulkPlant(payload).then((res) => {
        return res;
      });
    },
  },
};

export default plantsModule;
